import { FC } from 'react'
import { AnimatedPage } from 'components/Animated'
import { usePaidVideoCallFlowContext } from 'screens/PaidVideoCalls/context/PaidVideoCallFlowContext'
import { getPaidVideoCallFlow } from 'screens/PaidVideoCalls/types'

export const PaidCallFlowStep: FC<any> = ({ stepIndex }) => {
  const currentStep = getPaidVideoCallFlow()[stepIndex]
  const StepComponent = currentStep.routeComponent
  const { direction, resetBackDirection } = usePaidVideoCallFlowContext()

  return (
    <AnimatedPage direction={direction} resetBackDirection={resetBackDirection}>
      <StepComponent />
    </AnimatedPage>
  )
}
